import { useCallback } from 'react';

import { Filter, FilterResultStatus } from '@/components/filter';
import { Selector } from '@/components/selector';

import { BATCH_CALL_STATUS } from '@/constants';

import { type BatchCallStatusValue,useSchedulerListStore } from '@/store/schedule.store';
import type { BatchCall } from '@/types/scheduler.type';

const BatchCallStatusFilter = () => {
  const { filters, setFilter } = useSchedulerListStore();

  return (
    <Selector
      options={[{ value: 'All', label: 'All' }, ...BATCH_CALL_STATUS]}
      value={filters.status}
      onChange={value => setFilter('status', value as BatchCallStatusValue)}
    />
  );
};

export const BatchCallHeader = ({ batchCalls }: { batchCalls: BatchCall[] }) => {
  const { setQuery, query, filters, reset } = useSchedulerListStore();

  const handleClearQuery = useCallback(() => setQuery(''), [setQuery]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Filter
          placeholder="Search by name..."
          onFilter={setQuery}
          initialValue={query}
          onClear={handleClearQuery}
        />
        <BatchCallStatusFilter />
      </div>

      {(query || filters.status !== 'All') && (
        <FilterResultStatus
          resultsCount={batchCalls.length}
          onReset={reset}
          message="No batch calls match your search"
        />
      )}
    </div>
  );
};
